<template>
  <VDropdown
    :shown="isOpen && !disabled && items.length > 0"
    :triggers="[]"
    :auto-hide="false"
    :placement="placement"
    class="autocomplete position-relative"
  >
    <input
      ref="input"
      type="text"
      class="form-control"
      :value="modelValue"
      :disabled="disabled"
      @input="onInput"
      @focus="open"
      @blur="onBlur"
      @keydown.down.prevent="moveDown"
      @keydown.up.prevent="moveUp"
      @keydown.enter.prevent="selectCurrent"
      @keydown.esc.prevent="close"
    />
    <template #popper>
      <ul class="list-group autocomplete-suggestions">
        <li
          v-for="(item, i) in items"
          :key="item[valueAttribute] ?? i"
          :class="['list-group-item', { active: i === highlightedIndex }]"
          @mousedown.prevent="selectItem(item)"
          @mouseover="highlightedIndex = i"
        >
          {{ item[displayAttribute] }}
        </li>
      </ul>
    </template>
  </VDropdown>
</template>

<script>
export default {
  name: "AutoComplete",
  props: {
    modelValue: { type: String, default: "" },
    items: { type: Array, default: () => [] },
    displayAttribute: { type: String, default: "value" },
    valueAttribute: { type: String, default: "id" },
    placement: { type: String, default: "bottom-start" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "select"],
  data() {
    return {
      isOpen: false,
      highlightedIndex: 0,
      blurTimer: null
    };
  },
  watch: {
    items() {
      this.highlightedIndex = 0;
    }
  },
  beforeUnmount() {
    if (this.blurTimer) clearTimeout(this.blurTimer);
  },
  methods: {
    onInput(event) {
      this.$emit("update:modelValue", event.target.value);
      this.open();
    },
    open() {
      if (this.disabled || this.isOpen) return;
      this.isOpen = true;
      this.highlightedIndex = 0;
    },
    close() {
      this.isOpen = false;
    },
    onBlur() {
      if (this.blurTimer) clearTimeout(this.blurTimer);
      this.blurTimer = setTimeout(() => this.close(), 100);
    },
    moveDown() {
      if (!this.items.length) return;
      this.open();
      this.highlightedIndex = (this.highlightedIndex + 1) % this.items.length;
    },
    moveUp() {
      if (!this.items.length) return;
      this.open();
      this.highlightedIndex =
        (this.highlightedIndex - 1 + this.items.length) % this.items.length;
    },
    selectCurrent() {
      if (!this.isOpen || !this.items.length) return;
      this.selectItem(this.items[this.highlightedIndex]);
    },
    selectItem(item) {
      this.$emit("select", item);
      this.close();
    },
    setText(value) {
      this.$emit("update:modelValue", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.autocomplete-suggestions {
  max-height: 130px;
  overflow-y: auto;
  margin: 0;
}
</style>
